"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancelYellowToast = cancelYellowToast;
exports.default = watchers;
exports.getAllRecordsInList = getAllRecordsInList;
exports.getLabsOnHomeSummary = getLabsOnHomeSummary;
exports.getMyPrescriptionDetails = getMyPrescriptionDetails;
exports.getMyRecords = getMyRecords;
exports.markRecordViewed = markRecordViewed;
exports.orderPrescriptionRX = orderPrescriptionRX;
exports.orderPrescriptionTicketNotification = orderPrescriptionTicketNotification;
exports.postMyPrescriptionDetails = postMyPrescriptionDetails;
exports.recordRevampCount = recordRevampCount;
exports.updateLabsOnHomeReport = updateLabsOnHomeReport;
var _effects = require("redux-saga/effects");
var _sagas = require("../../../astercore/auth/login/redux/sagas");
var _utils = require("../../../common/utils/utils");
var api = _interopRequireWildcard(require("../api/records"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/*
    Request Params
    onSuccess: success callback
    onFailure: failure callback
    count: home many recent search items are required
*/
function* getMyRecords(request) {
  try {
    const {
      onSuccess,
      requestParams,
      showLoader = true
    } = request.data;
    if (_utils.isMobile && showLoader || !_utils.isMobile) {
      yield (0, _effects.put)(actions.GET_MY_RECORDS_API.request());
    }
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getMyRecords, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_MY_RECORDS_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse !== null && mainResponse !== void 0 ? mainResponse : []);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MY_RECORDS_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* getMyPrescriptionDetails(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.GET_MY_PRESCRIPTIONDETAILS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getMyPrescriptionDetails, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_MY_PRESCRIPTIONDETAILS_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      var _mainResponse$entry;
      onSuccess((_mainResponse$entry = mainResponse === null || mainResponse === void 0 ? void 0 : mainResponse.entry) !== null && _mainResponse$entry !== void 0 ? _mainResponse$entry : []);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_MY_PRESCRIPTIONDETAILS_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* postMyPrescriptionDetails(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.POST_MY_PRESCRIPTION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postMyPrescriptionDetails, requestParams, tokenData);
    yield (0, _effects.put)(actions.POST_MY_PRESCRIPTION_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.POST_MY_PRESCRIPTION_API.failure(err));
    yield (0, _effects.put)(actions.GET_MY_PRESCRIPTIONDETAILS_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* orderPrescriptionTicketNotification(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_TICKET_NOTIFICATION_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.orderPrescriptionTicketNotification, requestParams, tokenData);
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_TICKET_NOTIFICATION_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_TICKET_NOTIFICATION_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* orderPrescriptionRX(request) {
  try {
    const {
      onSuccess,
      requestParams
    } = request.data;
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_RX_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.orderPrescriptionRX, requestParams, tokenData);
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_RX_API.success(mainResponse));
    if (onSuccess && mainResponse && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.ORDER_PRESCRIPTION_RX_API.failure(err));
    if (request.data && request.data.onFailure) {
      request.data.onFailure(err);
    }
  }
}
function* uploadRecordAPI(params) {
  try {
    yield (0, _effects.put)(actions.UPLOAD_RECORD_WAITING_ROOM_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.uploadRecordWaitingRoom, params.data.params, tokenData);
    yield (0, _effects.put)(actions.UPLOAD_RECORD_WAITING_ROOM_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.UPLOAD_RECORD_WAITING_ROOM_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* syncStatusAPI(params) {
  try {
    const {
      onSuccess,
      requestParams
    } = params.data;
    yield (0, _effects.put)(actions.SYNC_STATUS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getSyncStatus, requestParams, tokenData);
    yield (0, _effects.put)(actions.SYNC_STATUS_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SYNC_STATUS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* syncDataAPI(params) {
  try {
    const {
      onSuccess,
      requestParams
    } = params.data;
    yield (0, _effects.put)(actions.SYNC_DATA_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.syncData, requestParams, tokenData);
    yield (0, _effects.put)(actions.SYNC_DATA_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.SYNC_DATA_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getLabsOnHomeSummary(requestParams) {
  const {
    onSuccess,
    onFailure,
    reqParams
  } = requestParams.data;
  try {
    yield (0, _effects.put)(actions.LABS_ON_HOME_SUMMARY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getLabsOnHomeSummary, reqParams, tokenData);
    yield (0, _effects.put)(actions.LABS_ON_HOME_SUMMARY_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.LABS_ON_HOME_SUMMARY_API.failure(err));
    onFailure(err);
  }
}
function* updateLabsOnHomeReport(requestParams) {
  const {
    onSuccess,
    onFailure,
    reqParams
  } = requestParams.data;
  try {
    yield (0, _effects.put)(actions.LABS_ON_HOME_MARK_REPORT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.markReportViewed, reqParams, tokenData);
    yield (0, _effects.put)(actions.LABS_ON_HOME_MARK_REPORT_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.LABS_ON_HOME_MARK_REPORT_API.failure(err));
    onFailure(err);
  }
}
function* guestFlowLabReports(params) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = params.data;
  try {
    yield (0, _effects.put)(actions.GUEST_FLOW_LAB_REPORTS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.guestFlowLabReports, requestParams, tokenData);
    yield (0, _effects.put)(actions.GUEST_FLOW_LAB_REPORTS_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GUEST_FLOW_LAB_REPORTS_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* getAllRecordsInList(params) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = params.data;
  try {
    yield (0, _effects.put)(actions.GET_ALL_RECORDS_LIST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getAllRecordsInList, requestParams, tokenData);
    yield (0, _effects.put)(actions.GET_ALL_RECORDS_LIST_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_ALL_RECORDS_LIST_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* markRecordViewed(params) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = params.data;
  try {
    yield (0, _effects.put)(actions.MARK_RECORD_VIEWED_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.markRecordViewed, requestParams, tokenData);
    yield (0, _effects.put)(actions.MARK_RECORD_VIEWED_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.MARK_RECORD_VIEWED_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* cancelYellowToast(params) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = params.data;
  try {
    yield (0, _effects.put)(actions.CANCEL_YELLOW_TOAST_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.cancelYellowToast, requestParams, tokenData);
    yield (0, _effects.put)(actions.CANCEL_YELLOW_TOAST_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.CANCEL_YELLOW_TOAST_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* recordRevampCount(params) {
  const {
    onSuccess,
    requestParams,
    onFailure
  } = params.data;
  try {
    yield (0, _effects.put)(actions.RECORD_REVAMP_COUNT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.recordRevampCount, requestParams, tokenData);
    yield (0, _effects.put)(actions.RECORD_REVAMP_COUNT_API.success(mainResponse));
    if (onSuccess && mainResponse) {
      onSuccess(mainResponse);
    }
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.RECORD_REVAMP_COUNT_API.failure(err));
    if (onFailure) {
      onFailure(err);
    }
  }
}
function* watchers() {
  yield (0, _effects.takeLatest)(actions.GET_MY_RECORDS, getMyRecords);
  yield (0, _effects.takeLatest)(actions.POST_MY_PRESCRIPTION, postMyPrescriptionDetails);
  yield (0, _effects.takeLatest)(actions.GET_MY_PRESCRIPTIONDETAILS, getMyPrescriptionDetails);
  yield (0, _effects.takeLatest)(actions.UPLOAD_RECORD_WAITING_ROOM, uploadRecordAPI);
  yield (0, _effects.takeLatest)(actions.SYNC_STATUS, syncStatusAPI);
  yield (0, _effects.takeLatest)(actions.SYNC_DATA, syncDataAPI);
  yield (0, _effects.takeLatest)(actions.ORDER_PRESCRIPTION_TICKET_NOTIFICATION, orderPrescriptionTicketNotification);
  yield (0, _effects.takeLatest)(actions.ORDER_PRESCRIPTION_RX, orderPrescriptionRX);
  yield (0, _effects.takeLatest)(actions.LABS_ON_HOME_SUMMARY, getLabsOnHomeSummary);
  yield (0, _effects.takeLatest)(actions.LABS_ON_HOME_MARK_REPORT, updateLabsOnHomeReport);
  yield (0, _effects.takeLatest)(actions.GUEST_FLOW_LAB_REPORTS, guestFlowLabReports);
  yield (0, _effects.takeLatest)(actions.GET_ALL_RECORDS_LIST, getAllRecordsInList);
  yield (0, _effects.takeLatest)(actions.MARK_RECORD_VIEWED, markRecordViewed);
  yield (0, _effects.takeLatest)(actions.CANCEL_YELLOW_TOAST, cancelYellowToast);
  yield (0, _effects.takeLatest)(actions.RECORD_REVAMP_COUNT, recordRevampCount);
}